<template>
    <b-col :cols="expandGraphs ? '12' : '3'" class="mb-4 d-flex justify-content-between">
        <b-card class="mb-0 five9-graphs-cards" :class="expandGraphs ? 'expand-graph' : '' " style="min-height:200px" v-b-visible="mountedAction">
            <template v-slot:header>
                <span class="h6">{{ title }}</span>
                <b-button @click="expandGraph" class="float-right">
                    <i class="far" :class="expandGraphs ? 'fa-compress-arrows-alt': 'fa-expand-arrows-alt' "></i>
                </b-button>
            </template>

            <template>



                <div class="text-center h5 mb-2 font-uppercase">{{ display_option }}</div>
                <span v-if="loading" style="min-height: 200px; padding-top:80px;">
                    <loading-spinner :busy="loading"></loading-spinner>
                </span>
                <ChartLine v-if="!loading && !barChart" :data="chartData" :options="chartData.options" :height="height" :width="width"></ChartLine>
                <VerticalBarLine class="" v-if="!loading && barChart" :data="chartData" :options="chartData.options" style="min-height: 500px"></VerticalBarLine>
                <div class="mt-4 text-center">
                    <b-button size="sm"
                              v-for="(opt,index) in options"
                              :key="index" variant="outline-dark"
                              @click="setOption(opt, $event)"
                              class="mr-1 option-btn">
                        <small>{{ options_text[index] || opt }}</small>
                    </b-button>
                </div>
            </template>
        </b-card>
    </b-col>
</template>

<script>
    import ChartLine from '../graphs/ChartLine.vue';
    import VerticalBarLine from '../graphs/ChartBar-Vertical.vue';
    import LoadingSpinner from "../../../components/LoadingSpinner";
    export default {
        name: 'DashboardGraph',
        components: {LoadingSpinner, ChartLine, VerticalBarLine},
        props: {
            width: {type: Number, default: undefined},
            height: {type: Number, default: undefined},
            title: String,
            load_url: String,
            color: {type: String, default: null},
            icons: {type: Array, default: []},
            time_wait: {type: Number, default: 10000000},
            options: {
                type: Array, default: function () {
                    return [];
                }
            },
            additional_chart_options: {
                default: null
            },
            barChart: {
                type: Boolean,
                default: false,
            },
            options_text: {
                type: Array, default: function () {
                    return [];
                }
            }
        },
        data(){
            return {
                chartData: {
                    labels: [],
                    datasets: [
                        {
                            borderColor: [],
//                            lineTension: 0.4,
                            pointBorderWidth: 2,
                            backgroundColor: [],
                            data: [],
                        }
                    ]
                },
                data: [],
                hasAction: false,
                expandGraphs: false,
                interval: null,
                loading: true,
                chart: null,
                processed: [],
                current_option: null,
                iconsData: [],
                display_option: null,
            };
        },
        mounted(){
        },
        beforeDestroy(){
            if (this.interaval) {
                clearInterval(this.interaval);
            }
            if (this.loading) {
                //clearInterval(this.loading);
            }
            if (this.chart) {
                this.chart.destroy();
            }
        },
        watch: {
            current_option: function(val) {
                val = val.replace(/_/g, " ");
                if(val == 'last7days') {
                    val = 'Last 7 Days'
                }
                this.display_option = val;
            }
        },
        methods: {
            mountedAction(viewable) {
                if(!this.hasAction && viewable) {
                    this.callAPI();
                    this.interaval = setInterval(
                        this.callAPI,
                        this.time_wait
                    );
                    this.hasAction = true;
                }
            },
            expandGraph(e) {
                let five9Card = document.querySelectorAll('.five9-graphs-cards');
                five9Card.forEach(function (card) {
                    card.classList.remove('expand-graph');
                });
                this.expandGraphs = !this.expandGraphs;
            },
            setOption(option, e){
                document.querySelectorAll('.option-btn').forEach(function (btn) {
                    btn.classList.remove('active');
                });
                e.target.classList.add('active');
                this.current_option = option;
                this.callAPI();
            },
            callAPI: function () {
                var _this = this;
                var url = this.load_url;

                if (this.current_option) {
                    url += '/' + this.current_option;
                } else if (this.options.length) {
                    this.current_option = this.options[0];
                    url += '/' + this.current_option;
                }

                this.$http.post(url).then(response => {
//                    console.log('response', response)
//                    _this.iconsData = response.data.data.labels || _this.icons || _this.icon;
//                    _this.data = response.data.data.chart_data || response.data.data;


                let dummieData = '{"labels":["OB Create Payment Issue","OB Follow Up","OB Kit Request - Non Converted","OB Kit Request - Non Converted 2","OB Offer Ready","OB Welcome"],"chart_data":[32,67,95,0,52,30],"cached":"false"}';

                    dummieData = JSON.parse(dummieData);
                    _this.data = dummieData.chart_data;
                    _this.iconsData = dummieData.labels;


                    _this.loading = false;
                    _this.createChartData();
                    _this.$forceUpdate();
                });
            },
            createChartData() {
                let icon = this.iconsData;
                let that = this;
                let i = 0;
                that.chartData.datasets[0].data = [];
                that.chartData.datasets[0].backgroundColor = [];
                that.chartData.labels = [];
                if(that.additional_chart_options) {
                    that.chartData = Object.assign({}, that.chartData, that.additional_chart_options);
                }
                icon.forEach(function (d) {
                    that.chartData.labels.push(that.iconsData ? that.iconsData[i] : '');

                    that.chartData.datasets[0].data.push(that.data ? that.data[i] : 0);

                    if(that.color) {
                        that.chartData.datasets[0].backgroundColor.push(that.color);
                    } else {
                        that.chartData.datasets[0].backgroundColor.push('rgba(32, 168, 216, .4)');
                    }

                    i++;
                });
            },
        }
    };
</script>

<style scoped>
    .display_on_top {
        z-index: 1000;
    }

    .card {
        flex: 1;
        margin: 0 8px;
        transition: .3s ease-in-out;
    }

    .card.expand-graph {
        flex: 5 !important;
    }
    .font-uppercase {
        text-transform: uppercase;
    }
</style>
